import { gql } from '@apollo/client'

/**
 * Graphql Query - To get the logged-in user's details
 */
export const MY_DETAILS = gql`
  query {
    me {
      name
      username
      id
      photo
      status
      isSuper
      role
      email
      phone
      isEmailVerified
      isPhoneVerified
      countryCode
      colorModePreference
      userPage {
        bio
        freightPreferences
      }
      notificationSettings {
        areAllNotificationsDisabled
        callAudioAndTranscriptNotifications {
          email
          sms
        }
        dispatcherAssignedNotifications {
          email
          sms
        }
        driverAssignedNotifications {
          email
          sms
        }
        loadPostBroadcastNotifications {
          email
          sms
        }
        postOfferChatNotifications {
          email
          inApp
          sms
          messageFilter
          receiveAutomatedMessages
        }
        shipmentChatNotifications {
          email
          inApp
          sms
          messageFilter
          receiveAutomatedMessages
        }
        teamMemberAssignedNotifications {
          email
          sms
        }
        teamMemberShipmentAssistanceRequestedNotifications {
          email
          sms
        }
        teamMemberShipmentExceptionDetectedNotifications {
          email
          sms
        }
        teamMemberShipmentStopArrivedNotifications {
          email
          sms
        }
        teamMemberShipmentStopDepartedNotifications {
          email
          sms
        }
        teamMemberShipmentStopGeofenceEnteredNotifications {
          email
          sms
        }
        teamMemberShipmentStopETAUpdatedNotifications {
          email
          sms
        }
        unreadMessageReminderNotifications {
          email
          inApp
          sms
          messageFilter
          receiveAutomatedMessages
        }
      }
      primaryMembership {
        role
        status
        accessType
        workspace {
          dot
          id
          displayName
          isEnterpriseWorkspace
          isVerified
          logo
          mcNumber
          workspacename
          workspaceVerificationType
        }
      }
      shipmentsPageSettings {
        hideNeedsCarrierShipments
      }
    }
  }
`

export const GET_SIGNED_URL = gql`
  query GetSignedURL($imageType: String!) {
    user: getSignedURL(input: { imageType: $imageType }) {
      url
    }
  }
`

/**
 * Get user page query
 * @param id user's uuid
 */
export const USER = gql`
  query User($id: ID!) {
    user(input: { id: $id }) {
      name
      id
      photo
      role
      username
      userPage {
        bio
        freightPreferences
      }
      primaryMembership {
        accessType
        isPrimary
        workspace {
          displayName
          logo
          isVerified
          dot
          company {
            id
            companyName
            mcNumber
            allowedToOperate
            authorizedForProperty
            authorizedForBroker
            brokerAuthorityStatus
            commonAuthorityStatus
            contractAuthorityStatus
            phoneNumber
            emailAddress
            faxNumber
            carrierOperation
            isHazmat
            numberOfPowerUnits
            numberOfDrivers
            mcsData {
              mcisAddDate
            }
          }
        }
      }
    }
  }
`
